/* tslint:disable */
/* eslint-disable */
/**
 * Revisdom API
 * Revisdom uygulaması için REST API dokümantasyonu
 *
 * The version of the OpenAPI document: v1
 * Contact: support@revisdom.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { RevisdomAPIViewModelsUserResponse } from './RevisdomAPIViewModelsUserResponse';
import {
    RevisdomAPIViewModelsUserResponseFromJSON,
    RevisdomAPIViewModelsUserResponseFromJSONTyped,
    RevisdomAPIViewModelsUserResponseToJSON,
    RevisdomAPIViewModelsUserResponseToJSONTyped,
} from './RevisdomAPIViewModelsUserResponse';

/**
 * API yanıtları için genel response modeli
 * @export
 * @interface ApiResponse1UserResponse
 */
export interface ApiResponse1UserResponse {
    /**
     * İşlemin başarılı olup olmadığını belirtir
     * @type {boolean}
     * @memberof ApiResponse1UserResponse
     */
    success?: boolean;
    /**
     * İşlem sonucu hakkında bilgi mesajı
     * @type {string}
     * @memberof ApiResponse1UserResponse
     */
    message?: string | null;
    /**
     * 
     * @type {RevisdomAPIViewModelsUserResponse}
     * @memberof ApiResponse1UserResponse
     */
    data?: RevisdomAPIViewModelsUserResponse;
    /**
     * Hata durumunda hata detayları
     * @type {{ [key: string]: Array<string>; }}
     * @memberof ApiResponse1UserResponse
     */
    errors?: { [key: string]: Array<string>; } | null;
}

/**
 * Check if a given object implements the ApiResponse1UserResponse interface.
 */
export function instanceOfApiResponse1UserResponse(value: object): value is ApiResponse1UserResponse {
    return true;
}

export function ApiResponse1UserResponseFromJSON(json: any): ApiResponse1UserResponse {
    return ApiResponse1UserResponseFromJSONTyped(json, false);
}

export function ApiResponse1UserResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApiResponse1UserResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'success': json['success'] == null ? undefined : json['success'],
        'message': json['message'] == null ? undefined : json['message'],
        'data': json['data'] == null ? undefined : RevisdomAPIViewModelsUserResponseFromJSON(json['data']),
        'errors': json['errors'] == null ? undefined : json['errors'],
    };
}

export function ApiResponse1UserResponseToJSON(json: any): ApiResponse1UserResponse {
    return ApiResponse1UserResponseToJSONTyped(json, false);
}

export function ApiResponse1UserResponseToJSONTyped(value?: ApiResponse1UserResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'success': value['success'],
        'message': value['message'],
        'data': RevisdomAPIViewModelsUserResponseToJSON(value['data']),
        'errors': value['errors'],
    };
}

